import { render, staticRenderFns } from "./FinishTest.vue?vue&type=template&id=22799722&scoped=true&"
import script from "./FinishTest.vue?vue&type=script&lang=js&"
export * from "./FinishTest.vue?vue&type=script&lang=js&"
import style0 from "./FinishTest.vue?vue&type=style&index=0&id=22799722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22799722",
  null
  
)

export default component.exports